export default __webpack_public_path__ + "static/media/india.0955c3b3.png";